import React, { Component } from 'react';
import axios from 'axios';
import { Provider } from 'react-redux';
import {
  Col,
  Container,
  Row,
  Card,
  Badge,
} from 'react-bootstrap';
import PropTypes from 'prop-types';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
// eslint-disable-next-line camelcase
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import moment from 'moment';
import Spinner from '../utils/Spinner';
import './Show.scss';
import OfflineSteps from "./OfflineSteps";
am4core.useTheme(am4themes_animated);

class Show extends Component {
  constructor(props) {
    super(props);

    this.state = {
      bill: {},
      billLoading: true,
      visibility: null,
      predictions: [],
    };
  }

  componentDidMount() {
    const { billId } = this.props;

    axios.get(`/bills/${billId}`)
      .then((response) => {
        this.setState({
          bill: response.data.bill.bill,
          house: response.data.bill.house,
          author: response.data.bill.author,
          notes: response.data.bill.notes,
          appointments: response.data.bill.appointments,
          visibility: response.data.bill.configuration.visibility,
          predictions: response.data.bill.predictions,
          lastPrediction: response.data.bill.last_prediction,
          billLoading: false,
        });
        this.thermometerReport();
      });
  }

  componentDidUpdate() {
    this.thermometerReport();
  }

  defColor(probability) {
    this.probability = probability;
    this.color = '#3ac47d';

    if (this.probability < 0.3) {
      this.color = '#dc3545';
    } else if (this.probability >= 0.3 && this.probability < 0.7) {
      this.color = '#f7b924';
    }

    return am4core.color(this.color);
  }

  thermometerReport() {
    this.chart = am4core.create('chartdiv', am4charts.XYChart);
    this.data = [];

    const { predictions } = this.state;
    const newPredictions = [];

    predictions.forEach((prediction, index) => {
      const newP = {
        date: prediction.observation_date,
        approval_probability: (parseFloat(prediction.approval_probability) * 100.0).toFixed(2),
        lineColor: this.defColor(
          predictions[index].approval_probability,
        ),
      };

      newPredictions.push(newP);
    });

    this.chart.data = newPredictions;

    this.categoryAxis = this.chart.xAxes.push(new am4charts.DateAxis());
    this.categoryAxis.renderer.grid.template.location = 0;
    this.categoryAxis.renderer.ticks.template.disabled = true;
    this.categoryAxis.renderer.line.opacity = 0;
    this.categoryAxis.renderer.grid.template.disabled = true;
    this.categoryAxis.renderer.minGridDistance = 60;
    this.categoryAxis.startLocation = 0;
    this.categoryAxis.endLocation = 1;

    this.valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
    this.valueAxis.tooltip.disabled = true;
    this.valueAxis.renderer.line.opacity = 0;
    this.valueAxis.renderer.ticks.template.disabled = true;
    this.valueAxis.min = 0;

    this.lineSeries = this.chart.series.push(new am4charts.LineSeries());
    this.lineSeries.dataFields.dateX = 'date';
    this.lineSeries.dataFields.valueY = 'approval_probability';
    this.lineSeries.tooltipText = 'Probabilidade: {valueY.value}%';
    this.lineSeries.fillOpacity = 0.5;
    this.lineSeries.strokeWidth = 3;
    this.lineSeries.propertyFields.stroke = 'lineColor';
    this.lineSeries.propertyFields.fill = 'lineColor';
    this.lineSeries.tensionX = 0.6;

    this.bullet = this.lineSeries.bullets.push(new am4charts.CircleBullet());
    this.bullet.circle.fill = am4core.color('#fff');
    this.bullet.circle.strokeWidth = 2;
    this.bullet.fillOpacity = 0;
    this.bullet.strokeOpacity = 0;

    this.bulletState = this.bullet.states.create('hover');
    this.bulletState.properties.fillOpacity = 1;
    this.bulletState.properties.strokeOpacity = 1;

    this.chart.cursor = new am4charts.XYCursor();
    this.chart.cursor.behavior = 'panX';
    this.chart.cursor.lineX.opacity = 0;
    this.chart.cursor.lineY.opacity = 0;

    // this.chart.scrollbarX = new am4core.Scrollbar();
    // this.chart.scrollbarX.parent = this.chart.bottomAxesContainer;
  }

  render() {
    const {
      billLoading,
      bill,
      author,
      house,
      notes,
      visibility,
      appointments,
      lastPrediction,
    } = this.state;

    return (
      <Provider store={store}>
        { billLoading ? <Spinner /> : (
          <Container fluid>
            <Row className="my-4">
              <Col className="mt-4 mb-4 text-center">
                <h1>{ bill.name }</h1>
                <h2>
                  { (author.name !== null && (`${author.name} - `))}
                  { author.party !== null && author.state !== null ? `(${author.party} - ${author.state})` : author.party !== null ? author.party : author.state }
                </h2>
                <h3>{ house.name }</h3>
              </Col>
            </Row>
            <Row className="my-4">
              {(visibility.highlight_last_step == true || visibility.offline_steps === true) && (
                <OfflineSteps visibility={visibility} bill={bill} />
              )}
              <Col md={5}>
                <Card>
                  <Card.Body>
                    <Card.Title>
                      Situação
                    </Card.Title>
                    { bill.status.replace(/<\/?[^>]+(>|$)/g, '') }
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <Row className="my-4">
              <Col md={4}>
                <Card className="mb-4">
                  <Card.Body>
                    <Card.Title>
                      Regime de tramitação
                    </Card.Title>
                    { bill.procedure }
                  </Card.Body>
                </Card>
                <Card className="mb-4">
                  <Card.Body>
                    <Card.Title>
                      Apreciação
                    </Card.Title>
                    { bill.appreciation }
                  </Card.Body>
                </Card>
                <Card className="mb-4">
                  <Card.Body>
                    <Card.Title>
                      Última relatoria
                    </Card.Title>
                    { bill.report_author }
                  </Card.Body>
                </Card>
              </Col>
              { visibility && visibility.appointments ? (
                <Col md={4}>
                  <Card>
                    <Card.Body style={{ maxHeight: '500px', overflowY: 'auto' }}>
                      <Card.Title>
                        Agenda
                      </Card.Title>
                      { appointments.length > 0 ? appointments.map((appointment) => (
                        <Card
                          bg="light"
                          key={appointment.id}
                          text="dark"
                          className="my-4"
                        >
                          <Card.Body>
                            <Card.Title>{`${appointment.title} - ${moment(appointment.timing).fromNow()}`}</Card.Title>
                            <Card.Text>
                              { appointment.description ? appointment.description.replace(/<\/?[^>]+(>|$)/g, '') : appointment.title }
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      )) : <Badge className="badge-warning">Nenhuma informação disponível</Badge> }
                    </Card.Body>
                  </Card>
                </Col>
              ) : null }
              <Col md={visibility && visibility.appointments ? 4 : 8}>
                <Card>
                  <Card.Body>
                    <Card.Title>
                      Ementa
                    </Card.Title>
                    { bill.description.replace(/<\/?[^>]+(>|$)/g, '') }
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            { visibility && (visibility.notes
              || visibility.thermometer
              || visibility.starred_notes) ? (
                <Row className="my-4">
                  { (visibility.notes || visibility.starred_notes) ? (
                    <Col md={visibility.thermometer ? 4 : 12}>
                      <Card>
                        <Card.Body>
                          <Card.Title>
                            Notas
                          </Card.Title>
                          { notes.length > 0 ? notes.map((note) => (
                            <Card.Body className="bg-light my-4">
                              <em>{note.details}</em>
                            </Card.Body>
                          )) : <Badge className="badge-warning">Nenhuma informação disponível</Badge> }
                        </Card.Body>
                      </Card>
                    </Col>
                  ) : null }
                  { visibility.thermometer ? (
                    <Col md={(visibility.notes || visibility.starred_notes) ? 8 : 12}>
                      <Card>
                        <Card.Body>
                          <Card.Title>
                            Termômetro
                          </Card.Title>
                          <h3>
                            Probabilidade atual de aprovação:
                            { ` ${(parseFloat(lastPrediction.approval_probability) * 100.0).toFixed(2)}%` }
                            <br />
                            <small>
                              Calculado em
                              { ` ${moment(lastPrediction.observation_date).format('DD/MM/YYYY')}` }
                            </small>
                          </h3>
                          <div id="chartdiv" style={{ height: '400px' }} />
                        </Card.Body>
                      </Card>
                    </Col>
                  ) : null }
                </Row>
              ) : null }
          </Container>
        )}
      </Provider>
    );
  }
}

Show.propTypes = {
  billId: PropTypes.string.isRequired,
};

export default Show;
